'use client';

import classnames from 'classnames';
import { IoClose } from 'react-icons/io5';

import type { BaseComponentProps } from '../../base-component.types';
import type { SelectOption } from './SelectOption.types';

import styles from './MultiselectOptions.module.scss';

type ContainerProps = BaseComponentProps & {
  options: SelectOption[];
  disabled?: boolean;
  onClick: (option: SelectOption) => void;
};

function MultiselectOptions({
  style,
  className,
  options,
  disabled = false,
  onClick,
  testId = 'ui-multiselect-options',
}: ContainerProps) {
  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      {options.map((option: SelectOption, index) => {
        return (
          <div
            className={styles['item']}
            key={option.value ?? index}
            data-testid={`${testId}_item_${index}`}
            role="listitem"
            aria-label={`Selected: ${option.label}`}
          >
            <span>{option.label}</span>
            <IoClose
              className={classnames(
                styles['close'],
                disabled && styles['close--disabled'],
              )}
              data-testid={`${testId}_item_${index}_remove`}
              onClick={() => {
                if (!disabled) {
                  onClick(option);
                }
              }}
              aria-hidden="true"
            />
          </div>
        );
      })}
    </div>
  );
}

export { MultiselectOptions };
